import { useContext } from "react";
import { ThemeNo } from "../../../../constant";
import { TableOrListStyleFunctiontyleOneReset } from "./TableOrListStyleFunction";
import { Button, Col, Container, Row } from "reactstrap";
import TableOrListThemeOne from "./TableOrListThemeOne";
import TableOrListingContext from "../../../context/TableOrListingContext/TableOrListingContext";

const TableOrListSettingParent = (props) => {
  const { imageUpload, handleSubmitSetting } = props;
  const {
    theme,
    setSettingFormData,
    setBoxSection,
    setBackImageToggle,
    setIsBackgroundColor,
  } = useContext(TableOrListingContext);
  const resetHandler = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = TableOrListStyleFunctiontyleOneReset;
    }
    setSettingFormData({ ...setStyle });
    setBoxSection(false);
    setBackImageToggle(false);
    setIsBackgroundColor(true);
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{"Edit"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              {+theme === ThemeNo.ThemeOne && (
                <TableOrListThemeOne
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TableOrListSettingParent;
